import {
    Container,
    Paper,
    Typography,
    Box,
    TextField,
    Button,
    FormControl,
    FormLabel,
    FormControlLabel,
    RadioGroup,
    Radio,
    MenuItem,
    Select,
    InputLabel,
    FormHelperText
} from "@mui/material";

import styles from "../../styles/backButton.module.scss";
import btnStyles from '../../styles/buttons.module.scss';
import FileUpload from "../application/FileUpload";

const today = new Date();
const todayString = new Date().toISOString().split("T")[0];
export default function DrivingLicenceForm({

    data,

    errors,

    handleChange,

    handleFileChange,

    paymentFrequency,

    onBack,

    onContinue

}) {


    const isMonthly = paymentFrequency === "Monthly";


    return (

            <Paper
                elevation={3}
                 sx={{
                    maxWidth: 1200,
                    mx: "auto",
                    mt: 4,
                    mb: 4,
                    px: { xs: 2, md: 4 },
                    py: 3,
                    borderRadius: 2
                }}
            >


                <Typography
                    variant="h4"
                    gutterBottom
                >

                    Driving Licence

                </Typography>


                <Typography sx={{mb:4, color: "rgba(0,0,0,0.6)",}}>

                    Please provide your driving licence information.

                </Typography>



                {/* Holds Licence */}

                <FormControl
                    error={!!errors.hasDrivingLicence}
                    sx={{mb:3}}
                >

                    <FormLabel sx={{color: "rgba(0,0,0,1)"}}>

                        Do you hold a current driving licence?

                    </FormLabel>


                    <RadioGroup

                        row

                        name="hasDrivingLicence"

                        value={data.hasDrivingLicence}

                        onChange={handleChange}

                    >

                        <FormControlLabel

                            value="true"

                            control={<Radio/>}

                            label="Yes"

                        />


                        <FormControlLabel

                            value="false"

                            control={<Radio/>}

                            label="No"

                        />


                    </RadioGroup>
                    {errors.hasDrivingLicence && (

                        <Typography
                            color="error"
                            variant="caption"
                        >
                            {errors.hasDrivingLicence}
                        </Typography>

                    )}

                </FormControl>



                {
                    data.hasDrivingLicence === "true" &&

                    <>


                        {
                            isMonthly &&

                            <>

                                <FormControl
                                    fullWidth
                                    error={!!errors.licenceType}
                                    sx={{mb:3}}
                                >

                                    <InputLabel>
                                        Licence Type
                                    </InputLabel>


                                    <Select
                                        name="licenceType"
                                        value={data.licenceType}
                                        onChange={handleChange}
                                        label="Licence Type"
                                       

                                    >

                                        <MenuItem value="Provisional">
                                            Provisional
                                        </MenuItem>


                                        <MenuItem value="Full">
                                            Full
                                        </MenuItem>


                                    </Select>
                                    <FormHelperText>
                                        {errors.licenceType}
                                    </FormHelperText>

                                </FormControl>



                                <TextField

                                    fullWidth

                                    sx={{mb:3}}

                                    label="Date Passed"

                                    type="date"

                                    name="datePassed"

                                    value={data.datePassed}

                                    onChange={handleChange}

                                    error={!!errors.datePassed}

                                    helperText={errors.datePassed}

                                    InputLabelProps={{
                                        shrink:true
                                    }}
                                    inputProps={{
                                        max: todayString
                                    }}
                                />


                            </>

                        }



                        {
                            !isMonthly &&

                            <TextField

                                fullWidth

                                sx={{mb:3}}

                                label="Class of Vehicle"

                                name="vehicleClass"

                                value={data.vehicleClass}

                                onChange={handleChange}

                                error={!!errors.vehicleClass}

                                helperText={errors.vehicleClass}

                            />

                        }




                        <FormControl
                            error={!!errors.endorsements}
                            sx={{mb:3}}
                        >

                            <FormLabel sx={{color: "rgba(0,0,0,1)"}}>

                                Any offence points endorsed?

                            </FormLabel>


                            <RadioGroup

                                row

                                name="endorsements"

                                value={data.endorsements}

                                onChange={handleChange}

                            >

                                <FormControlLabel

                                    value="true"

                                    control={<Radio/>}

                                    label="Yes"

                                />


                                <FormControlLabel

                                    value="false"

                                    control={<Radio/>}

                                    label="No"

                                />


                            </RadioGroup>
                            {errors.endorsements && (

                                    <Typography
                                        color="error"
                                        variant="caption"
                                    >
                                        {errors.endorsements}
                                    </Typography>

                                )}

                        </FormControl>




                        {
                            data.endorsements === "true" &&


                            <TextField

                                fullWidth

                                sx={{mb:3}}

                                label="How many points?"

                                name="endorsementsDetails"

                                value={data.endorsementsDetails}

                                onChange={handleChange}
                                error={Boolean(errors.endorsementsDetails)}
                                helperText={errors.endorsementsDetails}

                            />

                        }





                        {
                            isMonthly &&

                            <>

                            <Box sx={{ mt: 4 }}>
                                <FormControl
                                error={!!errors.drivesBusinessMiles}
                                    sx={{mb:3}}
                                >

                                    <FormLabel sx={{color: "rgba(0,0,0,1)"}}>

                                        Will you drive business miles in your own vehicle?

                                    </FormLabel>


                                    <RadioGroup

                                        row

                                        name="drivesBusinessMiles"

                                        value={data.drivesBusinessMiles}

                                        onChange={handleChange}

                                    >

                                        <FormControlLabel

                                            value="true"

                                            control={<Radio/>}

                                            label="Yes"

                                        />


                                        <FormControlLabel

                                            value="false"

                                            control={<Radio/>}

                                            label="No"

                                        />


                                    </RadioGroup>
                                     {errors.drivesBusinessMiles && (

                                    <Typography
                                        color="error"
                                        variant="caption"
                                    >
                                        {errors.drivesBusinessMiles}
                                    </Typography>

                                )}


                                </FormControl>
                            </Box>



                                {
                                    data.drivesBusinessMiles === "true" &&


                                    <FileUpload

                                        label="Upload Vehicle Insurance"

                                        file={data.vehicleInsuranceFile}

                                        onChange={handleFileChange}

                                        acceptedTypes={[
                                            "application/pdf",
                                            "image/jpeg",
                                            "image/png"
                                        ]}

                                        maxFileSize="10MB"

                                        error={
                                            errors.vehicleInsuranceFile
                                        }

                                    />


                                }


                                <Typography
                                    sx={{mt:3}}
                                >

                                    Please provide your driving licence on your first day of employment if you are to drive on Horbury Group business.

                                </Typography>


                            </>

                        }


                    </>

                }




                <Box

                    sx={{

                        display:"flex",

                        justifyContent:"space-between",

                        mt:5

                    }}

                >


                    <Button
                        variant="contained"
                        onClick={onBack}
                        className={styles.backSingleBtn}
                        sx={{  mt: "20px", mb: "20px"}}
                    >
                        Back
                    </Button>
                    <Button
                       className={btnStyles.btnDesktop}
                        variant="contained"
                        size="large"
                        sx={{ textTransform: 'none' }}
                        onClick={onContinue}
                    >
                        Continue
                    </Button>


                </Box>


            </Paper>

    );


}